<template>
  <div class="container">
    <div class="pt-5 mt-5">
      <div class="fs-2 fw-bold">ERORR 404</div>
      <div>terjadi kesalahan pada url, Halaman Page yang dituju tidak ada</div>
    </div>
  </div>
</template>
